"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ProjectInfoTrials_1 = require("./../interfaces/ProjectInfoTrials");
class ProjectInfoController {
    constructor() {
        this.projectInfo = {
            proposal: new ProjectInfoTrials_1.Proposal({}),
            project: new ProjectInfoTrials_1.Project({}),
            studies: [],
            counters: {
                pending_send: -1,
                pending_metadata: -1,
                pending_lab_but_sent: -1,
                analized: -1,
                at_lab: -1,
                study_finished: false,
            },
        };
        this.allSamples = [];
        this.loadingProjectInfo = false;
        this.callProjectInfoError = null;
    }
    async callProjectInfo(proposalId) {
        this.loadingProjectInfo = true;
        try {
            const call = await fetch(`/data/results/proposals/tracking/trials/${proposalId}`);
            const data = await call.json();
            this.projectInfo = data;
        }
        catch (error) {
            this.callProjectInfoError = error.message;
        }
        this.loadingProjectInfo = false;
    }
    async callProjectStudies(proposalId, projectId) {
        this.loadingProjectInfo = true;
        try {
            const call = await fetch(`/data/results/proposals/${proposalId}/tracking/${projectId}/studies`);
            const data = await call.json();
            this.projectInfo = data;
        }
        catch (error) {
            this.callProjectInfoError = error.message;
        }
        this.loadingProjectInfo = false;
    }
    async callSamplesGlobal(projectId) {
        this.loadingProjectInfo = true;
        try {
            const call = await fetch(`/tracking/project/samples/${projectId}`);
            const data = await call.json();
            this.allSamples = data;
        }
        catch (error) {
            console.log(error);
        }
        this.loadingProjectInfo = false;
    }
    get collectAllSamples() {
        return this.allSamples;
    }
    get collectProjectInfo() {
        return this.projectInfo;
    }
    get collectLoadingProjectInfo() {
        return this.loadingProjectInfo;
    }
    get collectNumberAllSamples() {
        var _a;
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.project.samples_count;
    }
    get collectCounterPendingSend() {
        var _a;
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters.pending_send;
    }
    get collectCounterAtLab() {
        var _a;
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters.at_lab;
    }
    get collectCounterPendingLabButSent() {
        var _a;
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters.pending_lab_but_sent;
    }
    get collectCounterPendingMetadata() {
        var _a;
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters.pending_metadata;
    }
    get collectCounterAnalyzed() {
        var _a;
        //console.log(this.projectInfo?.counters);
        return (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters.analized;
    }
    get collectColorStatePendingSend() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (((_b = (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters) === null || _b === void 0 ? void 0 : _b.pending_send) < 1 &&
            (((_d = (_c = this.projectInfo) === null || _c === void 0 ? void 0 : _c.counters) === null || _d === void 0 ? void 0 : _d.at_lab) > 0 ||
                ((_f = (_e = this.projectInfo) === null || _e === void 0 ? void 0 : _e.counters) === null || _f === void 0 ? void 0 : _f.pending_lab_but_sent) > 0 ||
                ((_h = (_g = this.projectInfo) === null || _g === void 0 ? void 0 : _g.counters) === null || _h === void 0 ? void 0 : _h.pending_metadata) > 0 ||
                ((_k = (_j = this.projectInfo) === null || _j === void 0 ? void 0 : _j.counters) === null || _k === void 0 ? void 0 : _k.analized) > 0)) {
            return 'success';
        }
        else {
            if (((_m = (_l = this.projectInfo) === null || _l === void 0 ? void 0 : _l.counters) === null || _m === void 0 ? void 0 : _m.pending_send) < 1) {
                return 'gray';
            }
            else {
                return 'primary';
            }
        }
    }
    get collectColorStateAtLab() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (((_b = (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters) === null || _b === void 0 ? void 0 : _b.pending_send) < 1 &&
            ((_d = (_c = this.projectInfo) === null || _c === void 0 ? void 0 : _c.counters) === null || _d === void 0 ? void 0 : _d.at_lab) < 1 &&
            ((_f = (_e = this.projectInfo) === null || _e === void 0 ? void 0 : _e.counters) === null || _f === void 0 ? void 0 : _f.pending_lab_but_sent) < 1 &&
            (((_h = (_g = this.projectInfo) === null || _g === void 0 ? void 0 : _g.counters) === null || _h === void 0 ? void 0 : _h.pending_metadata) > 0 ||
                ((_k = (_j = this.projectInfo) === null || _j === void 0 ? void 0 : _j.counters) === null || _k === void 0 ? void 0 : _k.analized) > 0)) {
            return 'success';
        }
        else {
            if (((_m = (_l = this.projectInfo) === null || _l === void 0 ? void 0 : _l.counters) === null || _m === void 0 ? void 0 : _m.at_lab) < 1) {
                return 'gray';
            }
            else {
                return 'primary';
            }
        }
    }
    get collectColorStatePendingMetadata() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (((_b = (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters) === null || _b === void 0 ? void 0 : _b.pending_send) < 1 &&
            ((_d = (_c = this.projectInfo) === null || _c === void 0 ? void 0 : _c.counters) === null || _d === void 0 ? void 0 : _d.at_lab) < 1 &&
            ((_f = (_e = this.projectInfo) === null || _e === void 0 ? void 0 : _e.counters) === null || _f === void 0 ? void 0 : _f.pending_lab_but_sent) < 1 &&
            ((_h = (_g = this.projectInfo) === null || _g === void 0 ? void 0 : _g.counters) === null || _h === void 0 ? void 0 : _h.pending_metadata) < 1 &&
            ((_k = (_j = this.projectInfo) === null || _j === void 0 ? void 0 : _j.counters) === null || _k === void 0 ? void 0 : _k.analized) > 0) {
            return 'success';
        }
        else {
            if (((_m = (_l = this.projectInfo) === null || _l === void 0 ? void 0 : _l.counters) === null || _m === void 0 ? void 0 : _m.pending_metadata) < 1) {
                return 'gray';
            }
            else {
                return 'primary';
            }
        }
    }
    get collectColorStateAnalyzed() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (((_b = (_a = this.projectInfo) === null || _a === void 0 ? void 0 : _a.counters) === null || _b === void 0 ? void 0 : _b.analized) ===
            ((_d = (_c = this.projectInfo) === null || _c === void 0 ? void 0 : _c.project) === null || _d === void 0 ? void 0 : _d.samples_count) &&
            ((_f = (_e = this.projectInfo) === null || _e === void 0 ? void 0 : _e.counters) === null || _f === void 0 ? void 0 : _f.analized) > 1 &&
            ((_h = (_g = this.projectInfo) === null || _g === void 0 ? void 0 : _g.counters) === null || _h === void 0 ? void 0 : _h.pending_send) < 1 &&
            ((_k = (_j = this.projectInfo) === null || _j === void 0 ? void 0 : _j.counters) === null || _k === void 0 ? void 0 : _k.at_lab) < 1 &&
            ((_m = (_l = this.projectInfo) === null || _l === void 0 ? void 0 : _l.counters) === null || _m === void 0 ? void 0 : _m.pending_lab_but_sent) < 1 &&
            ((_p = (_o = this.projectInfo) === null || _o === void 0 ? void 0 : _o.counters) === null || _p === void 0 ? void 0 : _p.pending_metadata) < 1) {
            return 'success';
        }
        else {
            if (((_r = (_q = this.projectInfo) === null || _q === void 0 ? void 0 : _q.counters) === null || _r === void 0 ? void 0 : _r.analized) < 1) {
                return 'gray';
            }
            else {
                return 'primary';
            }
        }
    }
}
exports.default = ProjectInfoController;
